module.exports = __webpack_public_path__ + "static/img/icon1a@2x.0c9cfc53.png";